import Dashboard from './Dashboard'
import Start from './Start'
import CropHome from './CropHome'
import LeaHome from './LeaHome'
import AboutEdison from './AboutEdison'

export default [{
  path: '/dashboard',
  name: 'Dashboard',
  component: Dashboard,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'Dashboard', tour: true},
  alias: '/'
}, {
  path: '/start',
  name: 'Start',
  component: Start,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'Let\'s start', tour: false}
}, {
  path: '/home/crop',
  name: 'CropHome',
  component: CropHome,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'CROP Home'}
},
{
  path: '/home/lea',
  name: 'LeaHome',
  component: LeaHome,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'LEA Home'}
},
{
  path: '/home/about-edison',
  name: 'AboutEdison',
  component: AboutEdison,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'More About Edison'}
}
]



// WEBPACK FOOTER //
// ./src/pages/home/router.js